import { Box, Container, Link, List, ListItem, Typography } from '@mui/material';
import { ENV } from 'src/global-config';

export function TermsAndConditionsEnglish({ sx, ...other }) {
  const env = ENV;
  const url = env === 'prod' ? 'https://www.shahen-sa.com' : 'https://shahen-sa.com/EnhancedUI';
  return (
    <Box
      component="section"
      sx={[
        {
          pb: 10,
          pt: { xs: 3, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box>
          <Box display="flex" justifyContent="around">
            <Box>
              <Box>
                <Box sx={{ m: 5 }}>
                  <Typography
                    component="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '24px',
                      margin: '10px 40px 0px 0px',
                      textAlign: 'center',
                    }}
                  >
                    Terms and Conditions
                  </Typography>
                  <br />
                  {/* <!--------------- About SHAHEN Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>About SHAHEN</Typography>
                  <Typography>
                    SHAHEN Platform, owned by Fikr Communications and Information Technology
                    Company, is a limited liability company registered in Saudi Arabia under
                    Commercial Registration No. 1010582007. The company's headquarters is located in
                    Riyadh, Saudi Arabia. "SHAHEN" is a registered trademark of Fikr Communications
                    and Information Technology Company, with trademark registration number
                    1442022156.
                  </Typography>{' '}
                  <br />
                  <Typography>
                    SHAHEN Platform is an advanced online platform designed to provide transport and
                    logistics services, connecting customers who need to transport their goods with
                    carriers who own suitable trucks for these tasks. The platform offers various
                    transportation services, including all types of trucks, aiming to provide safe
                    and efficient transport solutions covering all parts of Saudi Arabia.
                  </Typography>{' '}
                  <br />
                  <Typography>
                    Through SHAHEN Platform, users can request transport services, track shipments,
                    and obtain detailed reports on the status of their shipments. The platform is
                    committed to providing the highest standards of quality and safety in its
                    services, in compliance with the regulations and laws in force in Saudi Arabia.
                  </Typography>
                  {/* <!--------------- Introduction Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Introduction</Typography>
                  <Typography>
                    SHAHEN Platform aims to provide innovative and safe transport solutions,
                    connecting customers seeking cargo transport services with qualified carriers.
                    Through these terms and conditions, we strive to ensure a smooth and secure user
                    experience on our platform by defining the rights and obligations of all parties
                    involved.
                  </Typography>
                  <br />
                  <Typography>
                    Please read these terms and conditions carefully before using our services, as
                    they constitute a legally binding agreement between you and SHAHEN Platform.
                    Your continued use of the SHAHEN website and application implies your full
                    acceptance of all the terms and conditions set forth herein. SHAHEN Platform
                    reserves the right to modify these terms and conditions from time to time, and
                    the updates will be published on the website. Your continued use of the services
                    after the publication of the amendments constitutes acceptance of those changes.
                  </Typography>
                  <br />
                  <Typography>
                    We value your trust and are committed to providing the best possible service,
                    always striving to improve your experience with us. Thank you for choosing
                    SHAHEN Platform as a trusted partner to meet your transport and logistics needs.
                  </Typography>
                  {/* <!--------------- Objectives of the Terms and Conditions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Objectives of the Terms and Conditions
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Define the contractual relationship :
                        </Typography>{' '}
                        : Clarify the contractual relationship between SHAHEN Platform and the
                        customer, including the rights and obligations of each party.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Protect the rights of all parties :
                        </Typography>{' '}
                        Ensure the protection of the rights of all contracting parties, including
                        SHAHEN Platform, customers, and carriers, by establishing clear rules and
                        policies governing operations and services.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Ensure full transparency :
                        </Typography>{' '}
                        Enhance transparency in all transactions between SHAHEN Platform and
                        customers, ensuring clear terms and conditions related to the services
                        provided, prices, policies, and fees.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Ensure fair and appropriate use of services :
                        </Typography>{' '}
                        We collect information about your interactions with our platform, such as
                        pages visited, features used, and transaction history.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Define limits of liability :
                        </Typography>{' '}
                        Establish the limits of liability for SHAHEN Platform and the customer in
                        various scenarios, including transport, storage, and delivery, to avoid
                        potential disputes.
                      </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Risk management and compensation :
                        </Typography>{' '}
                        Outline policies related to insurance, compensation, and exceptions to
                        ensure effective risk management and protect the interests of all parties.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Regulate financial transactions :
                        </Typography>{' '}
                        Define financial policies related to fees, payments, and cancellations to
                        ensure a smooth and efficient financial process.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Provide dispute resolution mechanisms :
                        </Typography>{' '}
                        Establish clear and effective mechanisms for resolving disputes between
                        parties, including arbitration or recourse to judicial authorities, to
                        ensure fair and prompt resolution of disputes.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Compliance with laws and regulations :
                        </Typography>{' '}
                        : Ensure compliance with all local and international laws and regulations
                        related to transport and logistics services, enhancing the credibility and
                        reliability of SHAHEN Platform.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Achieve customer satisfaction :
                        </Typography>{' '}
                        Work to achieve the highest levels of customer satisfaction by providing
                        high-quality services and offering clear guidelines and policies to help
                        customers make the most of SHAHEN Platform's services.
                      </Typography>
                    </ListItem>
                  </List>
                  {/* <!--------------- Definitions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Definitions</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          SHAHEN Platform:
                        </Typography>{' '}
                        Refers to SHAHEN, the registered trademark of Fikr Communications and
                        Information Technology Company, a private limited liability company
                        providing transport and logistics services through an advanced online
                        platform covering all parts of Saudi Arabia.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Customer:
                        </Typography>{' '}
                        Refers to the individual or entity using SHAHEN Platform services to send or
                        receive goods.
                      </Typography>
                    </ListItem>

                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Authorized Representative:
                        </Typography>{' '}
                        The person authorized by the customer (whether an individual or a company)
                        to make decisions and sign documents related to the use of SHAHEN Platform
                        services on behalf of the customer.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Truck:
                        </Typography>{' '}
                        Refers to all types of trucks used in transport operations, including
                        TRAILA, SIX, LORRY, DIANA, and pickup trucks, whether refrigerated or
                        non-refrigerated.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Carrier:
                        </Typography>{' '}
                        The individual or company that owns the trucks and performs transport
                        operations through SHAHEN Platform..
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Driver:
                        </Typography>{' '}
                        The drivers affiliated with the carrier, responsible for driving the trucks
                        and loading and unloading goods according to SHAHEN Platform and customer
                        instructions.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Website:
                        </Typography>{' '}
                        Refers to SHAHEN's website accessible at{' '}
                        <Link href={url} target="_blank" rel="noopener noreferrer">
                          www.shahen-sa.com،
                        </Link>
                        , used by customers to obtain information about transport services and
                        manage orders.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Application:
                        </Typography>{' '}
                        Refers to the SHAHEN application available on smartphones, enabling
                        customers to manage their orders, track shipments, and benefit from the
                        transport services provided by SHAHEN Platform.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Goods:
                        </Typography>{' '}
                        Refers to all types of products or merchandise transported through SHAHEN
                        Platform services.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Load:
                        </Typography>{' '}
                        Refers to the quantity or volume of goods loaded onto the truck for
                        transport from one place to another.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Shipment:
                        </Typography>{' '}
                        Refers to the goods loaded onto the truck and prepared for transport from
                        the loading point to the delivery point.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Packaging according to specifications and standards:
                        </Typography>{' '}
                        Refers to the process of packing and wrapping goods according to
                        international and local standards and specifications to ensure their safety
                        during transport..
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Transport:
                        </Typography>{' '}
                        The process of moving goods from the loading site to the delivery site using
                        designated trucks through SHAHEN Platform services.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Shipping:
                        </Typography>{' '}
                        Refers to the process of loading goods onto trucks and delivering them to
                        their final destination through SHAHEN Platform services.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Bill of Lading:
                        </Typography>{' '}
                        The official document issued by SHAHEN Platform or the carrier, containing
                        details of the shipment such as the type of goods, quantity, destination,
                        and loading and delivery information.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Insurance:
                        </Typography>{' '}
                        The service provided by SHAHEN Platform to cover damages or losses that may
                        occur to the goods during transport, according to the terms and conditions
                        of the approved insurance policy.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Contract:
                        </Typography>{' '}
                        The legal agreement between the customer and SHAHEN Platform, specifying the
                        terms and conditions for using the transport services provided through the
                        platform.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Fees:
                        </Typography>{' '}
                        The financial costs incurred by the customer for using SHAHEN Platform
                        services, including cancellation fees, delay fees, overnight fees, unpaved
                        road fees, and high-traffic area fees.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Liability:
                        </Typography>{' '}
                        The obligations borne by the customer, carrier, or SHAHEN Platform regarding
                        the execution of transport operations and compensation for damages or losses
                        that may arise.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Invoice:
                        </Typography>{' '}
                        The financial document issued by SHAHEN Platform to the customer, containing
                        details of the fees due for the services provided.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Loading:
                        </Typography>{' '}
                        The process of placing goods onto the truck at the loading site in
                        preparation for their transport to the specified destination.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Unloading:
                        </Typography>{' '}
                        The process of removing goods from the truck at the delivery site.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Loading and delivery points:
                        </Typography>{' '}
                        The specific geographic locations where goods are loaded onto the truck and
                        unloaded from it.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Waiting Period:
                        </Typography>
                        The time during which the driver waits at the loading or delivery site due
                        to the customer's delay, unavailability of the goods, or the delivery site
                        being unprepared for receipt.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Customer Service:
                        </Typography>
                        The department responsible within SHAHEN Platform for handling customer
                        inquiries and complaints and providing necessary support.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          {' '}
                          Supervisor:
                        </Typography>
                        The person responsible for overseeing transport operations, ensuring they
                        are carried out in accordance with the approved terms and conditions, and
                        intervening in emergencies or disputes.
                      </Typography>
                    </ListItem>
                  </List>
                  {/* <!--------------- General Terms Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>General Terms: </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Terms of Use:</Typography>
                  <Typography>
                    Access or use by individuals from any country worldwide of the applications,
                    websites, content, products, and services provided by "SHAHEN" Platform, a
                    trademark owned by Fikr Communications and Information Technology Company, is
                    governed by these terms and conditions. Please read these terms carefully before
                    obtaining or using the services as they constitute a contractual relationship
                    between you and SHAHEN Platform. These terms replace any prior agreements or
                    arrangements made with you. Fikr Communications and Information Technology
                    Company may terminate these terms or any of your related services immediately or
                    suspend the services in general, or deny access to any part thereof at any time
                    and for any reason.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Supplementary Terms:</Typography>
                  <Typography>
                    Some supplementary terms may apply to specific services, such as policies for a
                    particular event, activity, or promotional campaign. In the event of a conflict
                    regarding the provided services, the supplementary terms shall prevail and are
                    considered part of the provided services. SHAHEN Platform and Fikr
                    Communications and Information Technology Company may amend the terms related to
                    the services from time to time, and such amendments shall take effect upon
                    posting the updated terms on this site or posting the amended policies regarding
                    the provided service. Continuing to access or use the services after such
                    posting constitutes your agreement to be bound by the terms as amended.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Privacy Policy:</Typography>
                  <Typography>
                    In accordance with what is stipulated in the privacy policy, we collect and use
                    personal data concerning the services provided to you. SHAHEN Platform and Fikr
                    Communications and Information Technology Company may provide necessary
                    information (including your contact information) to claims settlement companies
                    or insurance companies in the event of a complaint or dispute between you and an
                    external service provider (including the carrier). This information or data is
                    necessary to settle the complaint, dispute, or disagreement. SHAHEN Platform
                    reserves the right to use some of the non-confidential customer data, such as
                    names and logos, in the context of indirect promotion and marketing of its
                    services, which contributes to enhancing mutual trust with customers and
                    developing the provided services, provided that the confidentiality of the
                    non-disclosed data is maintained and intellectual property rights are not
                    infringed.
                  </Typography>
                  {/* <!--------------- Customer Responsibilities Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Customer Responsibilities:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Providing Correct Information:
                  </Typography>
                  <Typography>
                    The customer or their representative is responsible for providing the company
                    with a list of any hidden or illegal items or items that are against the
                    applicable laws, as well as dangerous and harmful items that may cause losses or
                    damages or pose risks to people or property, including the lives of the team
                    responsible for transporting them. In this case, the customer will be
                    responsible for all expenses incurred due to the loss or damage caused by the
                    company due to non-disclosure or deliberate concealment of any information or
                    data related to this type of items/goods/shipment.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Receiving Goods:</Typography>
                  <Typography>
                    If the customer fails to receive the goods at the agreed place and time, they
                    will be responsible for all related delay expenses, including overnight expenses
                    or any additional fees, which will be calculated according to the company's
                    tariff. The customer must receive the goods within a period not exceeding 48
                    hours from the date the truck arrives at the delivery site, after which the
                    company will not be responsible for any damages, spoilage, or loss of the goods.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Delivery Failure:</Typography>
                  <Typography>
                    In case of failure to deliver the goods for any reason, such as SHAHEN being
                    unable to contact the customer, or the customer's refusal or neglect to receive
                    the goods, the customer remains responsible for any costs and/or fees and/or
                    expenses resulting from returning or destroying the goods, or any additional
                    fees resulting from these terms and conditions.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Delays and Notification:
                  </Typography>
                  <Typography>
                    The customer must notify SHAHEN in writing if they wish to delay delivery and
                    store the goods in the truck before placing the order. If the company is not
                    notified, the customer bears all financial and legal responsibilities resulting
                    from this, and the company is not responsible for any damages that may occur to
                    the goods due to this delay.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Customer Responsibility to Government Authorities:
                  </Typography>
                  <Typography>
                    If the shipment is refused, seized, or confiscated by government authorities,
                    SHAHEN is not responsible for compensating the customer or intervening in the
                    clearance of the goods or reviewing government authorities. This responsibility
                    lies with the customer, including paying all related fees and expenses.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Code Submission:</Typography>
                  <Typography>
                    The customer must close the order through their account or provide the
                    verification code to the carrier after unloading the goods within 30 minutes. If
                    the code is not provided within the specified time, the order will be
                    automatically closed without any responsibility on SHAHEN Platform.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Preparing the Bill of Lading:
                  </Typography>
                  <Typography>
                    If the sender prepares the bill of lading themselves, they bear full
                    responsibility for the accuracy of the data and information listed. If SHAHEN
                    prepares the bill of lading on their behalf, the sender is responsible for
                    providing accurate data to ensure the bill of lading is prepared correctly.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Incorrect Data:</Typography>
                  <Typography>
                    If the provided data is incorrect, such as delivery addresses or recipient
                    information, the customer bears all costs that may arise. If the address is
                    changed, any additional fees requested by the carrier due to the change of
                    address will be entirely borne by the customer. SHAHEN Platform is not
                    responsible for any additional fees imposed by the carrier in such cases.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Signing the Shipping Document:
                  </Typography>
                  <Typography>
                    Both the sender and the recipient are obligated to sign the shipping document
                    clearly, and SHAHEN Platform may use any appropriate means instead of the
                    signature, such as verification through technical means or any other means of
                    proof that SHAHEN Platform deems appropriate.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Shipment Inspection:</Typography>
                  <Typography>
                    The beneficiary accepts that SHAHEN Platform has the right to open and inspect
                    the shipment at any time during transportation without prior notice, and the
                    beneficiary's acceptance of these terms and conditions constitutes acceptance of
                    this.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Direct Agreement with Carrier:
                  </Typography>
                  <Typography>
                    SHAHEN Platform is not responsible for any agreement made directly between the
                    customer and the carrier or their affiliates without prior written approval from
                    SHAHEN Platform. Any agreement or consequences arising from this are entirely
                    the customer's responsibility and are considered a violation of SHAHEN
                    Platform's rights.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>Fees and Violations:</Typography>
                  <Typography>
                    The customer bears the payment of any fees and fines resulting from improper
                    loading or non-compliance with the regulations concerning the permissible
                    loading weight according to traffic and governmental authorities, and any costs
                    caused by the customer.
                  </Typography>
                  {/* <!--------------- Payment and Financial Transaction Policies Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', ml: 4 }}>
                    Payment and Financial Transaction Policies:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer is responsible for paying all fees and costs associated with the
                      service, including loading and unloading fees, delay fees, overnight fees, and
                      fees for unpaved roads and vital areas.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      Multiple fees may apply, and more than one fee may apply to a single trip.
                      These fees are billed either within the same order invoice or through a
                      separate external invoice, and the customer must pay them according to the
                      policies adopted by SHAHEN Platform.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      The customer is not allowed to negotiate the fees or delay their payment.
                      SHAHEN Platform has the right to take appropriate measures to protect its
                      rights and the rights of its carriers, including withholding the delivery of
                      the cargo until the fees are paid. SHAHEN Platform is not responsible for any
                      disruption or delay caused by the customer's delay in paying the fees, which
                      may result in additional fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      {' '}
                      It is prohibited to pay any amounts directly to the carrier or their
                      affiliates. Any payments must be made through the official means specified by
                      SHAHEN Platform to ensure transparency and security in financial transactions.
                      If the customer pays amounts directly to the carrier, SHAHEN Platform is not
                      responsible for the trip, and the order is considered unpaid. The customer
                      must pay the agreed fee to SHAHEN Platform, which has the right to take
                      appropriate legal action according to its policy. SHAHEN Platform also has the
                      right to cancel the order without waiving its fees and rights from that trip.
                    </ListItem>
                  </List>
                  {/* <!--------------- Limitation of Liability  Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Limitation of Liability:{' '}
                  </Typography>
                  <Typography>
                    SHAHEN Platform provides certain information and materials as a service, either
                    through SHAHEN or its suppliers or otherwise. The information and materials
                    provided on the website or application are provided "as is," and are not
                    prepared considering the purposes or situations or specific needs of individual
                    users, and are provided without any warranties of any kind, express or implied.
                    SHAHEN Platform does not make any warranties or representations regarding the
                    use or the results of using the website or linked websites or the application in
                    terms of their correctness, accuracy, timeliness, reliability, or otherwise.
                    SHAHEN Platform is not responsible for any errors or incorrect data, and does
                    not bear contractual or tortious liability (including negligence) or otherwise
                    for any loss or damage of any kind whatsoever (including direct or indirect,
                    consequential, or special losses or damages, or loss of profit). You release
                    SHAHEN Platform from all claims arising from any statement or representation on
                    the website or application or any affiliated platform. The only and
                    comprehensive remedy available to you for any of the above or for any dispute
                    with SHAHEN Platform or its affiliates or any of its officers, directors,
                    employees, shareholders, or agents is to cease using the site. SHAHEN Platform
                    disclaims to the fullest extent permitted by applicable law all liability and
                    obligations related to the website and disclaims all express and implied
                    warranties, including but not limited to implied warranties of merchantability
                    and fitness for a particular purpose. SHAHEN Platform does not guarantee that
                    the services included on the website and application will be uninterrupted or
                    error-free, or that defects will be corrected, or that the website or the server
                    that provides the website is free of viruses or other harmful elements. To the
                    fullest extent permitted by law, you agree to indemnify SHAHEN Platform and its
                    officers and employees against all costs, expenses, and damages incurred in
                    connection with any claim brought by third parties against SHAHEN Platform
                    arising out of any breach by you of these terms of use. You acknowledge that the
                    limitation of liability and indemnification provisions extend to all affiliates
                    of SHAHEN Platform, including any parent or subsidiary companies.
                  </Typography>
                  {/* <!--------------- Registration  Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Registration: </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Types of Users:</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      There are two types of users on the website:
                    </Typography>{' '}
                    "Customers with SHAHEN Accounts" and "Customers without SHAHEN Accounts."
                    Although registration and account creation are not mandatory, registering grants
                    you access to additional functionalities available on the website.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    Registration and Account Creation:
                  </Typography>
                  <Typography>
                    To become a registered "Customer with a SHAHEN Account," you (or your company if
                    you are registering on behalf of the company you work for) must complete the
                    registration process with SHAHEN Platform. This requires providing us with your
                    personal or company information. Providing inaccurate information may result in
                    account suspension. SHAHEN Platform reserves the right to refuse any
                    registration request at its discretion.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>User Obligations:</Typography>
                  <Typography>
                    Completing the registration process on behalf of your company constitutes a
                    commitment that you have the authority to bind your company and that you
                    guarantee compliance with these terms and conditions by any other employee using
                    the website. These terms and conditions are in addition to any contract you may
                    enter into with SHAHEN Platform regarding your account.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Account Security:</Typography>
                  <Typography>
                    Login must be performed using your mobile number and the verification code sent
                    to your phone. You must ensure that your account information is secure and
                    confidential and not disclosed to anyone else. You acknowledge full
                    responsibility for your account and must notify SHAHEN Platform immediately of
                    any unauthorized use of your account or any other security breach related to
                    your account.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>User Responsibility:</Typography>
                  <Typography>
                    You acknowledge and agree that SHAHEN Platform is not responsible for any loss
                    or damage resulting from the fraudulent use of your account and release SHAHEN
                    Platform from all claims arising from unauthorized use of your account.
                    Additionally, you acknowledge that SHAHEN Platform is not responsible for
                    ensuring the accuracy, completeness, or timeliness of any information related to
                    you or your company and agree to monitor and update any such information.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    Termination of Registration:
                  </Typography>
                  <Typography>
                    You or SHAHEN Platform may terminate your registration at any time and for any
                    reason without written notice. Once your registration is terminated by SHAHEN
                    Platform, you will not be able to access any part of the website designated for
                    registered users without prior approval from SHAHEN Platform.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Use of the Website:</Typography>
                  <Typography>
                    If you use the website to request that SHAHEN Platform perform a task on your
                    behalf, we will send an email to the address you provide during the registration
                    process to confirm receipt of your request. While SHAHEN Platform makes every
                    effort to ensure the reliability of the services provided on the website, the
                    nature of the internet means that we cannot be held responsible for requests
                    that we have not confirmed receipt of.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Data Entry:</Typography>
                  <Typography>
                    SHAHEN Platform may retain any data you provide while using the website, and it
                    does so in accordance with our privacy policy. You acknowledge that SHAHEN
                    Platform may delete this data at any time and that you are solely responsible
                    for maintaining a backup copy of this data, as SHAHEN Platform is not
                    responsible for its loss or deletion.
                  </Typography>
                  {/* <!--------------- Data Security  Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Privacy Policy </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Data Collection</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Types of Data We Collect:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Personal Data:
                        </Typography>{' '}
                        Includes name, address, phone number, email, and other information that can
                        be used to identify an individual.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Non-Personal Data:
                        </Typography>{' '}
                        Includes data that does not directly identify an individual, such as general
                        usage information, device type, IP address, browsing history, and more.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Methods of Data Collection:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          During Registration:
                        </Typography>{' '}
                        We collect data when creating an account on the SHAHEN Platform.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          During Use:
                        </Typography>{' '}
                        We collect data during your use of our applications and services, including
                        when placing shipping requests, contacting customer service, or interacting
                        with website content.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          From Third Parties:
                        </Typography>{' '}
                        We may obtain data from our partners or other service providers who
                        collaborate with us.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Data Use</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Purposes for Which We Use Data:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Improving Services:
                        </Typography>{' '}
                        We use data to deliver and enhance our services, including personalizing
                        user experiences and developing new features.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Communication:
                        </Typography>{' '}
                        We use data to communicate with you regarding your account, shipping
                        requests, and service updates.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Security:
                        </Typography>{' '}
                        We use data to maintain the security of your account and protect our
                        platform from fraudulent or illegal activities.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Marketing:
                        </Typography>{' '}
                        We use data to send promotional offers and marketing content that may
                        interest you, based on your consent.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Data Sharing:</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Information Sharing:</Typography>
                  <Typography>
                    SHAHEN Platform may share your information with third parties to improve the
                    service. These third parties include governmental and non-governmental entities,
                    business partners, and other service providers. This is done in accordance with
                    applicable policies and procedures, and relevant laws and regulations.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Situations Where Information May Be Shared Include (but are not limited to):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Compliance with legal or regulatory requirements.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Improving user experience and provided services.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Handling complaints and disputes.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Enhancing security and preventing fraudulent or illegal activities.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For marketing, advertising, and promotional purposes.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          With Service Providers:
                        </Typography>{' '}
                        We share data with our partners and service providers who assist us in
                        providing our services, such as insurance companies, carriers, the Transport
                        Authority, the Ministry of Transport, and claims settlement companies.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          For Legal Purposes:
                        </Typography>{' '}
                        We share data when necessary to comply with laws and regulations or upon the
                        request of governmental or judicial authorities.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    By agreeing to use the services of SHAHEN Platform, you acknowledge and agree to
                    share your data with the aforementioned third parties. If you do not agree to
                    share your data, you must immediately stop using the services of SHAHEN Platform
                    and delete the application.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Customer Rights</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Right of Access:
                        </Typography>{' '}
                        You have the right to access the personal data we hold about you and request
                        a copy of it.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Right to Rectification:
                        </Typography>{' '}
                        You have the right to request the correction of any inaccurate or incomplete
                        data we hold about you.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Right to Erasure:
                        </Typography>{' '}
                        You have the right to request the deletion of your personal data from our
                        records, unless there is a legal or operational reason preventing us from
                        doing so.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Right to Object:
                        </Typography>{' '}
                        You have the right to object to the processing of your data in certain
                        cases, such as for direct marketing purposes.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Right to Data Portability:
                        </Typography>{' '}
                        You have the right to request the transfer of your personal data to another
                        entity based on your request.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Data Confidentiality</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Security Measures:
                        </Typography>{' '}
                        We are committed to taking all reasonable security measures to protect your
                        personal data from unauthorized access, alteration, disclosure, or
                        destruction.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Access Restriction:
                        </Typography>{' '}
                        We limit access to your personal data to employees and partners who need it
                        to provide the agreed-upon services.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Data Retention:
                        </Typography>{' '}
                        We retain your personal data only for as long as necessary to achieve the
                        purposes for which it was collected, or as required by law.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Emergency Procedures:
                        </Typography>{' '}
                        have contingency plans and immediate response procedures for security
                        breaches or data incidents.
                      </Typography>
                    </ListItem>
                  </List>
                  {/* <!--------------- Cookies Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Cookies</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Use of Cookies</Typography>
                  <Typography>
                    SHAHEN Platform uses cookies to enhance your experience when visiting our
                    website or using our application. Cookies are small text files stored on your
                    device when you visit our website or use our application, and they help improve
                    website and application functions and provide a personalized experience.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Types of Cookies We Use
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Essential Cookies:
                        </Typography>{' '}
                        These cookies are necessary to enable you to navigate the site and use its
                        features, such as accessing secure areas of the site. Without these cookies,
                        the services you have requested cannot be provided.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Essential Cookies:
                        </Typography>
                        Performance Cookies: These cookies collect information about how visitors
                        use the site, such as which pages they visit most often, and help us improve
                        the site's performance. These cookies do not collect information that
                        identifies a visitor.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Essential Cookies:
                        </Typography>
                        Functional Cookies: These cookies allow the site to remember choices you
                        make (such as your username, language, or the region you are in) and provide
                        enhanced, more personalized features. These cookies can also remember
                        changes you have made to text size, fonts, and other customizable parts of
                        web pages.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          Essential Cookies:
                        </Typography>
                        Marketing and Advertising Cookies: These cookies are used to deliver
                        advertisements relevant to you and your interests. They are also used to
                        limit the number of times you see an advertisement and to help measure the
                        effectiveness of advertising campaigns. These cookies are usually placed by
                        advertising networks with the site operator’s permission. They remember that
                        you have visited the site and this information is shared with other
                        organizations, such as advertisers.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>How to Manage Cookies</Typography>
                  <Typography>
                    You can control or delete cookies through your browser settings. You can delete
                    all cookies that are already on your device and most browsers can be set to
                    prevent them from being placed. However, if you do this, you may need to
                    manually adjust some preferences every time you visit the site, and some
                    services and functionalities may not work properly.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Consent to Use of Cookies
                  </Typography>
                  <Typography>
                    By using Shahen’s website or application, you consent to our use of cookies as
                    described in this policy. If you do not agree to our use of cookies, you should
                    set your browser settings accordingly or stop using the site and application.
                  </Typography>
                  {/* <!--------------- Updates Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Updates</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Updating the Privacy Policy
                  </Typography>
                  <Typography>
                    We may update this cookie policy from time to time to reflect changes in our
                    practices or for other operational, legal, or regulatory reasons. We will post
                    any changes to this policy on our site or application.
                  </Typography>
                  <Typography>
                    If you have any questions or comments regarding the cookie policy, you can
                    contact us via email or other available contact methods on the site.
                  </Typography>
                  <Typography>
                    We reserve the right to update the privacy policy from time to time to reflect
                    changes in our practices or applicable laws. You will be notified of any
                    significant changes through the website or other appropriate means.
                  </Typography>
                  <Typography>
                    By using Shahen’s platform, you agree to the above terms and conditions and
                    acknowledge that you understand and agree to the collection and use of your
                    personal data as described.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Notification</Typography>
                  <Typography>
                    {' '}
                    Shahen may send notifications by sending a general service or application
                    notice, by emailing you at the address registered in your account information
                    with Shahen, or by sending a regular mail to the address registered in your
                    account information with Shahen.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Contact Us</Typography>
                  <Typography>
                    For inquiries and policies: If you have any questions or comments regarding the
                    privacy policy, you can contact us via email or other available contact methods
                    on the site.
                  </Typography>
                  <Typography>
                    By using Shahen, you agree to this privacy policy and acknowledge that you
                    understand and agree to the collection and use of your personal data as
                    described.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Intellectual Property</Typography>
                  <Typography>
                    All rights related to the Shahen website and mobile applications (collectively
                    referred to as "Shahen"), including copyrights, trademarks, logos, designs,
                    software, text and graphic content, computer programs, icons, images, audio
                    clips, videos, data, information, and all other materials available through the
                    platform (collectively referred to as "content") are the exclusive property of
                    Shahen or its licensors and are protected by local and international
                    intellectual property laws.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Use of Content</Typography>
                  <Typography>
                    • It is strictly prohibited to copy, modify, distribute, publish, download,
                    display, transmit, sell, or reproduce any part of the content without prior
                    written permission from Shahen.
                  </Typography>
                  <Typography>
                    {' '}
                    • Users are permitted to use the content only for their personal, non-commercial
                    purposes and in accordance with these terms and conditions of use.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Trademarks</Typography>
                  <Typography>
                    • All trademarks and logos displayed on Shahen are owned by Shahen or its
                    licensors. Using any trademark in any manner without prior written permission
                    from the trademark owner is prohibited.
                  </Typography>
                  <Typography>
                    {' '}
                    • This includes trademarks such as "Shahen," associated logos, and any other
                    names or symbols identifying Shahen's services.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Software Rights</Typography>
                  <Typography>
                    • Shahen owns all software rights used to operate the website and applications.
                    No one is permitted to copy, modify, distribute, or resell any part of the
                    software.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Prohibited Use</Typography>
                  <Typography>
                    • The use of any automated means such as robots, spiders, or other automated
                    tools to access any part of Shahen or copy content from it is prohibited.
                  </Typography>
                  <Typography>
                    {' '}
                    • Attempting to decompile or reverse engineer any part of the software used on
                    Shahen is prohibited.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>User-Submitted Content</Typography>
                  <Typography>
                    • Any content submitted or uploaded by users to Shahen (including comments,
                    ratings, photos, etc.) becomes the property of Shahen. Shahen has the right to
                    use it in any manner deemed appropriate, including for marketing and promotional
                    purposes, without the need to obtain prior user consent or provide compensation.
                  </Typography>
                  <Typography>
                    {' '}
                    • The user guarantees that the submitted content does not violate any third
                    party’s intellectual property rights and assumes full responsibility for any
                    breach of this warranty.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    {' '}
                    Breach of Intellectual Property
                  </Typography>
                  <Typography>
                    • Shahen reserves the right to take all appropriate legal actions against any
                    unauthorized use of its content, software, or trademarks. • If any intellectual
                    property rights violation is discovered, users must immediately notify Shahen to
                    take the necessary actions.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Indemnification</Typography>
                  <Typography>
                    • The user agrees to indemnify Shahen for all damages, losses, and costs that
                    may arise from any breach of intellectual property rights by the user or
                    licensed parties.
                  </Typography>
                  <Typography>
                    This section aims to protect Shahen's intellectual property rights and ensure
                    its lawful and ethical use by all users. Your use of Shahen signifies your
                    agreement to comply with these intellectual property terms and conditions.
                  </Typography>
                  {/* <!--------------- Insurance Policy Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Insurance Policy</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Definition:</Typography>
                  <Typography>
                    At Shahen, we always strive to ensure the safety and security of our customers'
                    goods with the highest standards of quality and safety. Cargo insurance is a
                    vital measure aimed at protecting your valuable property from potential risks
                    during transportation. Insurance acts as a financial safety net that protects
                    goods from damages caused by accidents or circumstances beyond our control. We
                    work with highly reputable and reliable insurance companies to ensure the best
                    coverage for our customers' goods.
                  </Typography>
                  <br />
                  <Typography>
                    Choosing insurance is a necessary and mandatory step for every customer. The
                    customer must provide all accurate information and data related to the
                    transported goods. Failure to provide correct and complete information is
                    considered negligence and the customer will bear full responsibility. In the
                    event of any damage to the goods due to failure to provide the necessary
                    information, Shahen disclaims responsibility for covering such damages, and the
                    customer will be fully responsible for any potential losses.
                  </Typography>
                  <br />
                  <Typography>
                    Providing incorrect data, such as the value or type of goods, invalidates the
                    insurance policy, and the customer has no right to claim any compensation. We
                    believe that insuring goods enhances trust between us and our customers and
                    reflects our commitment to providing reliable and efficient transportation
                    services. Insurance allows our customers to conduct their business with
                    confidence and peace of mind, knowing that their property is protected in the
                    best possible way.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Definitions</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Insured:
                    </Typography>{' '}
                    The person or entity for whose benefit the goods or property are insured under
                    the insurance policy.
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      {' '}
                      Insurance:
                    </Typography>{' '}
                    The contract by which the insurer undertakes to indemnify the insured for
                    damages or losses that the insured goods may suffer during a specified period.{' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      {' '}
                      Customer:
                    </Typography>{' '}
                    The person or entity requesting transportation or storage services from Shahen.{' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Shahen:
                    </Typography>{' '}
                    The trademark owned by Fikr for Communications and Information Technology,
                    providing transportation and storage services for goods through an integrated
                    electronic platform.{' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Packaging and Packing according to Specifications and Standards:
                    </Typography>{' '}
                    The procedures and standards followed in packaging and packing goods to ensure
                    their safety during transportation and storage. These procedures must comply
                    with recognized international specifications and standards.{' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Loading and Stacking according to International Standards:
                    </Typography>{' '}
                    The process of loading and arranging goods on transportation means in a manner
                    that complies with international standards to ensure safety and efficiency in
                    transportation.
                  </Typography>
                  <br />
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Insured Item:
                    </Typography>{' '}
                    The goods or property insured under the insurance policy.
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      {' '}
                      Value of the Insured Item:
                    </Typography>{' '}
                    The financial value of the goods or property insured as specified in the
                    insurance policy and is the basis for calculating compensation in case of loss
                    or damage.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    Clause on Packaging and Loading according to International Standards
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Packaging and Packing according to International Standards:
                    </Typography>{' '}
                    Customers must ensure that all goods transported through Shahen are packed and
                    packaged according to the highest international standards and specifications to
                    ensure their safety and protection during transportation and storage. Below are
                    some essential points to consider:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    1.Materials Used for Packaging:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      High-quality packaging materials suitable for the type of goods transported
                      must be used.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Packaging materials should be strong and durable to protect the goods from
                      shocks and damage.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Double-walled cardboard boxes or wooden crates are preferred when necessary.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}> 2.Internal Packing:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Goods must be tightly packed inside boxes to prevent movement during
                      transportation.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Use internal packing materials like foam, bubble wrap, and cardboard to ensure
                      goods remain stable and prevent movement.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>3.Sealing Boxes:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Boxes should be well sealed with strong adhesive tape to ensure they do not
                      open during transportation.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Use wide, high-quality adhesive tape.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    4.Warning Labels and Stickers:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Appropriate warning labels such as "Fragile," "Keep Dry," and "This Side Up"
                      should be placed on the boxes.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Use stickers with clear details of the load and address.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>5.Special Packaging:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Some goods may require special packaging, such as refrigerated or frozen
                      products, which need insulating packaging to maintain temperature.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Liquids should be tightly packed to prevent leakage.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    6.International Standards:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The packaging and packing process must comply with international standards and
                      specifications such as ISO, ASTM, ISTA to ensure quality and safety.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Review standards specific to the type of goods to ensure correct procedures
                      are followed.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    7.Manufacturer's Guidelines:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Follow the manufacturer's guidelines regarding how to pack and package the
                      product to ensure its safety.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Check specific instructions for each product to apply best packing practices.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>8.Documentation:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Keep all documents and invoices that prove the details of the goods and
                      packaging.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Provide these documents upon request to ensure that the goods comply with
                      specifications and standards.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>
                    Loading and Stacking According to International Standards
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Loading and Stacking:
                    </Typography>{' '}
                    The process of loading and stacking goods in trucks must adhere to the highest
                    international standards to ensure their safety and security during
                    transportation. Below are the basic guidelines for loading and stacking that the
                    insured or the loading party must verify and apply:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Pre-planning:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The loading process should be pre-planned to ensure optimal use of truck
                      space.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Determine the maximum allowable weight for the truck and distribute the weight
                      evenly to avoid overloading.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Using Appropriate Equipment:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Use appropriate equipment such as forklifts, straps, and ropes to safely load
                      goods.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Ensure the equipment used is compatible with the type and size of the
                      transported goods.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Securing and Fastening:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Secure the goods inside the truck firmly using straps and ropes to prevent
                      movement during transportation.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Use additional securing means such as dividers and bumpers to ensure the
                      stability of the goods.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Even Distribution:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Distribute the weight evenly inside the truck to prevent the goods from
                      sliding or the truck from overturning.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Arrange the goods in a way that ensures easy access during unloading.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Ensuring Ventilation:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If transporting goods that require ventilation, ensure there are adequate
                      ventilation openings in the truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Maintain an appropriate temperature for heat-sensitive goods.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Verification of Fastening:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The insured or the loading party must verify the proper fastening of the goods
                      before the trip begins.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Ensure no unsecured items could pose a risk during transportation.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Compliance with International Standards:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The loading and stacking process must comply with international standards and
                      specifications such as ISO and ASTM to ensure quality and safety.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Review the instructions specific to each type of goods to apply the best
                      loading and stacking practices.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Manufacturer's Guidelines:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Follow the manufacturer's guidelines regarding how to load and stack the
                      product to ensure its safety.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Verify the instructions specific to each product to apply the best loading and
                      stacking practices.
                    </ListItem>
                  </List>
                  <Typography>
                    By following these guidelines, Shahen ensures the safety of goods and their
                    protection from damage during transportation and storage, thereby enhancing
                    customer trust in its services and ensuring the highest levels of satisfaction.
                  </Typography>
                  {/* <!----------------- Coverage Clause Related Terms ---------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 4 }}>Coverage Clause</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Coverage:
                    </Typography>{' '}
                    The insurance policy provided by Shahen covers all risks related to the loss or
                    damage of goods during transportation, including damages resulting from
                    accidents, fire, explosions, and theft, provided these risks are not mentioned
                    in the exclusions clause. The coverage also includes damages that may occur due
                    to natural factors such as rain or floods, provided the goods are appropriately
                    packed and protected according to the approved international standards.
                    Additionally, the coverage includes damages resulting from mishandling or
                    negligence by the carriers or their drivers, as long as this negligence is not
                    mentioned within the exclusions. The insurance policy covers all goods that are
                    correctly disclosed in the bill of lading, and the compensation value is
                    determined based on the value of the insured goods as stated in the insurance
                    policy. The customer must review the exclusions clause to understand all the
                    cases not covered by the insurance. In the event of any conflict between the
                    coverage and exclusions, the exclusions shall prevail.{' '}
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Coverage Includes:
                    </Typography>
                  </Typography>
                  <br />
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      All types of goods and products unless mentioned in the exclusions clause.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Damages resulting from accidents (such as traffic accidents).
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Damages resulting from natural disasters (such as floods, earthquakes).
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Damages resulting from fires and explosions.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Theft, provided it does not conflict with the exclusions clause.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Damages resulting from mishandling or negligence by the carriers or their
                      drivers.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      All goods that are correctly packed and packaged according to approved
                      standards and specifications.
                    </ListItem>
                  </List>
                  <Typography>
                    We draw the customer’s attention to the necessity of reviewing the exclusions
                    clause to understand the cases not covered by the insurance, which may affect
                    claim submission.
                  </Typography>
                  {/* <!--------------- Insurance Exclusions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Insurance Exclusions</Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4, ml: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Tobacco products, cigarettes, cigars, and alcoholic beverages.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Gold-plated watches and jewelry, and watches made of gold.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Silver, precious metals, and gemstones.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Paper money, coupon bonds, promissory notes, and securities.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Documents and manuscripts.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Storage of goods in transit.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or destruction to glass, porcelain, ceramic items, scientific
                        instruments, or marble or plaster statues.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Theft of goods while the truck is at any of the insured's or their clients'
                        sites.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Any loss or damage caused by liquid or gaseous goods leaking or spilling
                        from containers.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss to temporary property stored for more than seven days during
                        transit for storage, repacking, or processing purposes.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Theft or embezzlement caused by any employee of the primary or secondary
                        insured.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Loss or damage to the insured goods due to temperature variations. Insurance
                        does not cover damages resulting from temperature variations unless caused
                        by a cooling device failure for no less than 12 consecutive hours.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Radiation contamination: Shahen is not responsible for the loss,
                        destruction, or damage of property resulting from ionizing radiation or
                        radioactive contamination from any nuclear fuel or nuclear waste generated
                        from the combustion of nuclear fuel.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss attributable to deliberate misconduct by the insured.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Ordinary leakage, loss in weight, or wear and tear of the insured goods.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or costs due to inadequate or inappropriate packing or preparation of
                        the insured goods.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Loss or damage caused by inherent vice or the nature of the insured goods.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss directly caused by delays, even if caused by insured perils.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss arising from issues related to weapons of war using nuclear
                        fission or reaction or other radioactive activities.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss arising from any strike, labor disturbance, riot, or civil
                        commotion.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss caused by wars, civil wars, revolutions, rebellions, and
                        insurrections.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage or loss caused by seizure, detention, or arrest.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Failure to collect the transported goods by the client within the specified
                        time.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Lack of a police report in the event of accidents.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Failure to load and unload according to the required international
                        standards.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Any loss or damage caused by bacteria, fungi, microbes, viruses, and similar
                        risks.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Failure to park the truck in a secured area at any of the client's premises.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage from rainwater unless transported in a closed vehicle, and damage
                        resulting from negligence in choosing the appropriate truck type for the
                        cargo, such as selecting an open truck leading to damage due to weather
                        conditions like rain, or transporting valuable goods in open trucks, making
                        them susceptible to theft.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Penalty exclusion clause.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Loading goods higher than the truck sides.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Overloading the truck beyond the permitted weight limit.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Mechanical, electrical, and electronic deviations and latent defects.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        This insurance coverage is based on the fully insured amount. In case of
                        declaring any value less than the actual value of the goods, it will be
                        considered a breach of the utmost good faith principle, and the claim will
                        be denied.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Delay in notifying Shahen, resulting in the disappearance of evidence or
                        difficulty verifying the incident.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Products that are not properly packed and stacked according to
                        specifications and standards.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Loading outside the truck perimeter.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Fragile products like mirrors placed loosely and not on pallets, or
                        unwrapped and unstacked marble on pallets.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Screens, radios, recorders, and used or new devices not packed and stacked
                        according to specifications and standards.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Goods exceeding a value of 500,000 SAR unless prior approval is obtained.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Loss, destruction, or damage to high-risk livestock.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Livestock of all kinds.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Electrical cables and copper.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Loading a truck not matching the truck details specified in the platform or
                        bill of lading.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Falling or damage to goods during loading or unloading.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Falling goods or parts of them due to poor roads or rugged paths at the
                        loading or unloading site, provided there are no alternative safe roads.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Minor scratches, dents, or discoloration of the shipment. If the damage is
                        external or superficial and does not prevent the use of the product, such as
                        a scratch or tear in the packaging without damage to the internal product.
                        For example, an oil can deformed by a fall or pressure but with no oil
                        leakage.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Damage to part of the whole, where only the damaged part is compensated
                        without the intact part.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Lack of valid invoices or documents proving the value of the insured goods.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Missing or lost part of the goods without photos showing the state of the
                        goods after loading and a photo of the goods before unloading showing the
                        shortage and rearrangement of the goods. The insured must provide Shahen
                        with a video of the truck after loading from surveillance cameras at the
                        loading site and another video upon the carrier's arrival at the unloading
                        site.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Unregistered trips on the Shahen platform or those for which the client did
                        not submit an official request, such as cooperating with a Shahen-affiliated
                        driver without submitting a request or agreeing with one of Shahen's
                        representatives in violation of platform policies and without written and
                        official permission.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Exclusion of leakage and contamination clause.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        War, sabotage, terrorism, political risks, and SRCC risks.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>Cyber-attack exclusion clause. CL. 380- I 0.1 1.03.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        Political risks, financial guarantees, and credit risks exclusion clause.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    Shahen is committed to protecting its customers' rights and ensuring a safe and
                    efficient transport experience. In the event of any of the above-mentioned
                    cases, the insurance will not cover the resulting damages, and the client will
                    bear full responsibility for any additional costs or losses.
                  </Typography>
                  {/* <!--------------- Clause on Liability in Cases of Intentional Negligence by the Carrier Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Clause on Liability in Cases of Intentional Negligence by the Carrier
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Definition:
                    </Typography>{' '}
                    In some cases, such as intentional and unintentional negligence by the carrier
                    resulting in damage to or loss of goods, the insurance may not cover these
                    damages. In these cases, the carrier will be legally pursued after evidence is
                    provided and the claim is verified. To submit a valid claim, the client must
                    provide evidence showing changes in the arrangement or condition of the goods
                    after loading from cameras or photos at the loading site, and photos or videos
                    of the goods at the delivery site showing changes in arrangement and condition
                    before unloading, along with any additional documents. It should be noted that
                    the carrier is not responsible for inventorying the loaded goods and accounting
                    for what is inside them due to the impossibility of doing so. The insurance
                    company considers the carrier insured for the goods, and any negligence or
                    deliberate damage by the carrier voids the insurance and necessitates legal and
                    judicial proceedings to claim compensation directly from the carrier. Examples
                    include:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        If a carrier or their affiliate steals the goods or part of them or
                        conspires with others to steal them in an unsecured area, not at the
                        client's site or in a location without surveillance cameras, insurance
                        compensation will be denied. In this case, Shahen will file a lawsuit
                        against the carrier to prove the driver's actions.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        If products requiring refrigeration or freezing are transported and the
                        driver tampers with the cooling device or the cooling device malfunctions
                        during transport, resulting in goods damage, insurance compensation will be
                        denied as the damage was caused by the carrier. Shahen will pursue legal and
                        judicial action against the carrier to recover the client's rights.
                      </Typography>
                    </ListItem>
                  </List>
                  <Typography>
                    {' '}
                    The insured client must cooperate with Shahen in all cases to legally prove
                    their rights. Shahen will spare no effort in pursuing the responsible party
                    legally and judicially to recover and restore the client's rights.
                  </Typography>
                  <Typography>
                    It should be clear that the client does not have the right to sue Shahen or its
                    employees or Fikr for Communications and Information Technology for any direct
                    compensation or liability. Shahen's role is to direct freight vehicles, and the
                    carrier is responsible. By using Shahen's services, the client agrees to
                    indemnify Shahen and its employees and owners from any legal accountability that
                    may arise. The client must cooperate with Shahen and shield it from harm in all
                    cases, releasing it from any liability.
                  </Typography>
                  {/* <!--------------- Prohibitions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Prohibitions</Typography>
                  <Typography>
                    Users of Shahen’s platform applications and website are prohibited from the
                    following:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Transporting or sending prohibited and banned goods and materials:
                      </Typography>
                    </ListItem>
                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                      <ListItem sx={{ display: 'list-item' }}>
                        This includes hazardous chemicals, transporting money, and any materials
                        that violate the regulations in force in the Kingdom of Saudi Arabia.
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        The user alone bears full responsibility for any violation of these
                        regulations.
                      </ListItem>
                    </List>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Transporting or sending prohibited and banned goods and materials:
                      </Typography>
                    </ListItem>
                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                      <ListItem sx={{ display: 'list-item' }}>
                        It is prohibited to use Shahen’s platform applications and website for
                        transporting individuals within or outside cities.
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        It is prohibited to use the applications and website for any purposes other
                        than those intended.
                      </ListItem>
                    </List>
                  </List>
                  <Typography>
                    By using Shahen’s platform applications and website, you agree to comply with
                    all applicable laws and regulations and bear full responsibility for any
                    violation that may occur.
                  </Typography>
                  {/* <!--------------- Insurance Claims Submission Mechanism Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Insurance Claims Submission Mechanism
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Submitting and Following Up on a Claim:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Verify Coverage:
                      </Typography>{' '}
                      Check the schedule and your policy wording to see if it covers the loss or
                      damage and if any specific evidence is required.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Read the General Conditions:
                      </Typography>{' '}
                      Read the general conditions and follow any mentioned instructions.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Contact Shahen:
                      </Typography>{' '}
                      Contact Shahen to submit your claim.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Required Documents:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The following documents are typically an essential part of the claim and
                      should be submitted to the company: <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          Commercial invoices to support values and specify the terms of sale.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Packing lists, if any.</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Delivery receipts, shipping accounts, etc., as evidence of the condition
                          and status of any loss incurred.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Original transport documents, such as the bill of lading or transport
                          agreement.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Correspondence with carriers, suppliers, or other third parties to hold
                          them accountable for any loss.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          An account or estimate of the amounts claimed.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Any other relevant documents for the shipment, transport, or loss.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Follow-Up on the Claim:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Assigning an Independent Assessor:
                      </Typography>{' '}
                      Upon notification, the company will assign an independent assessor to examine
                      the case to establish the precise conditions and extent of the loss. This
                      process will be carried out with minimal delay and at the company's expense.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Claim Processing:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        What We Will Do:
                      </Typography>{' '}
                      In most cases, we can settle the claim based on the information provided in
                      the claim form, with the required original documents. Sometimes, it may be
                      necessary to appoint an agent to help us reach a quick and fair settlement of
                      the claim. Our agent will contact you as soon as possible to arrange a meeting
                      to discuss the claim.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Remedies and Legal Responsibility:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Remedies:
                      </Typography>{' '}
                      Before or after covering the costs of your claim under this policy, if
                      requested, you must allow us to use your name in all necessary steps until
                      your rights against any other party are exhausted, and we will pay any costs
                      and expenses incurred.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Jurisdiction:
                      </Typography>{' '}
                      With regard to legal liability to third parties for injuries or damages
                      arising in the Kingdom of Saudi Arabia, we will only pay for cases that
                      occurred in the Kingdom of Saudi Arabia.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The company, as the manager of the insurance policyholders’ account for
                      insured participants, manages insurance operations and the rights and
                      responsibilities arising from them. For this purpose, the company manages two
                      separate accounts: the policyholders’ account for insured participants to
                      record subscriptions.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Terms and Conditions of Coverage:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      These are the conditions along with any special conditions, and compliance
                      with them is necessary. Failure to do so may mean that we will not accept any
                      claim under this insurance.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      All reasonable steps must be taken to prevent accidents and loss or damage or
                      liability as if you were uninsured.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If any different loss or legal liability under this policy is covered by
                      another insurance, we will not pay more than our share of any claim.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      You cannot transfer your interest in this policy to any other person unless
                      you get written permission.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Claims Notification:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      You or your representative must contact us as soon as possible and provide
                      complete information once you become aware that something has happened that
                      requires making a claim. You must notify us in writing or by phone. If there
                      is a theft, attempted theft, vandalism, or any malicious act, you must also
                      notify the police immediately.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Evidence:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      You must send us any evidence we request related to your claim, and its costs
                      will be your responsibility. Some items have specific requirements, please
                      read the item on how to make a claim to see this.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Making a Claim:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      You must not settle or refuse any claim or negotiate with a third party
                      without obtaining written permission. We have the right in our name and yours
                      to: <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          Take over the legal defense or settle any claim.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Start legal proceedings in your name to obtain compensation from any other
                          person.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Start legal proceedings in your name to recover any payments from any
                          other person that have already been made.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  {/* <!--------------- Policy Cancellation Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Policy Cancellation:</Typography>
                  <Typography>
                    Your policy may be canceled by the company at any time if:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The insured has not complied with any warranty or improved the risk in a
                      certain manner and within the required time as specified in this document.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      There is any fraudulent misrepresentation or non-disclosure of any material
                      fact. Definition: A material fact is one that affects the company's ability to
                      decide whether to accept the risk or not, and if the company decides to accept
                      the terms, it may do so.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The interest of the insured in this policy can be stopped or may be materially
                      or fundamentally changed.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      There is a significant change in the profession, processing process,
                      procedures, or any other substantial modifications to the risks.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Right to Reject Compensation Request:
                    </Typography>{' '}
                    Shahen reserves the right to reject a compensation request or refuse to consider
                    it and not submit it to the insurance company if it violates the insurance
                    policy or any of its clauses.
                  </Typography>
                  {/* <!--------------- Duties of the Insured Customer Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Duties of the Insured Customer:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Providing Accurate Data:{' '}
                      </Typography>{' '}
                      customer must provide accurate and correct data when entering the order
                      information, including addresses, value of goods, type of goods, and required
                      temperature for perishable goods.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Updating Information:{' '}
                      </Typography>{' '}
                      The customer must update any information related to the order in case of any
                      changes to ensure accuracy and integrity of the process.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Cooperating with Shahen:{' '}
                      </Typography>{' '}
                      customer must fully cooperate with Shahen at all stages of the transport,
                      including providing the necessary documents and evidence to support any claim
                      or damage.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Following Instructions and Guidelines:
                      </Typography>{' '}
                      The customer must follow the instructions and guidelines provided by Shahen to
                      ensure smooth operation, including loading and unloading directions, and
                      procedures for reporting damages or shortages.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Providing Necessary Documents:{' '}
                      </Typography>{' '}
                      customer must provide all necessary documents to support any claim, such as
                      commercial invoices, packing lists, delivery receipts, and other required
                      documents.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Adhering to Specified Times:
                      </Typography>{' '}
                      The customer must receive the transported goods within the specified time and
                      avoid delaying the receipt process to prevent any additional fees or damage to
                      the goods.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Immediate Damage Reporting:{' '}
                      </Typography>{' '}
                      customer must immediately report any damages or shortages that occur to the
                      goods during transport, and not close the order until the condition is
                      verified and the damages are assessed in the presence of the driver or carrier
                      representative.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Following Legal Procedures:{' '}
                      </Typography>{' '}
                      In case of any damages due to negligence or intentional acts by the carrier,
                      the customer must cooperate with Shahen in taking the necessary legal actions
                      against the carrier and provide all required evidence and documents to support
                      the case.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Bearing Additional Costs:{' '}
                      </Typography>{' '}
                      customer must bear any additional costs resulting from the use of unpaved
                      roads or loading and unloading in vital areas, as well as any fees resulting
                      from delays or overnight stays.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Not Transferring Risk Responsibility:
                      </Typography>{' '}
                      The customer is responsible for compensating the carrier for any damages to
                      the carrier's trucks or properties resulting from the use of unpaved roads or
                      non-compliance with proper loading and unloading procedures.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Providing Accurate Temperature:{' '}
                      </Typography>{' '}
                      customer must provide the accurate required temperature for perishable goods
                      in the order notes to ensure the safety of the goods. Example: The required
                      temperature is 0 degrees Celsius minimum and not exceeding 4 degrees Celsius.
                    </ListItem>
                  </List>
                  <Typography>
                    By fulfilling these duties, the customer ensures the protection of their rights,
                    the smooth and efficient transport process, and minimizes the risks associated
                    with transport and insurance.
                  </Typography>
                  {/* <!--------------- Additional Fees and Charges Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Additional Fees and Charges:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Customer's Acknowledgment and Commitment to Pay Fees:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      • The customer commits to paying all fees arising from the services provided
                      by Shahen, including but not limited to cancellation fees, delay fees,
                      overnight fees, unpaved road usage fees, and loading and unloading fees in
                      vital areas. The customer acknowledges that these fees may apply to the same
                      trip and may be billed either within the order invoice itself or as a separate
                      external invoice.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Terms and Conditions:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer is obligated to pay these fees immediately upon issuance and has
                      no right to negotiate or delay their payment.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Shahen reserves the right to take appropriate measures to protect its rights
                      and the rights of its carriers, including withholding delivery of the cargo
                      until the due fees are paid.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Shahen is not responsible for any disruption or delay that may occur to the
                      goods due to the customer's delay in paying the fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer bears all damages and additional fees that may arise from the
                      delay in paying the fees, including any other fees resulting from this delay.
                    </ListItem>
                  </List>
                  {/* <!--------------- Liability Statement Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Liability Statement:</Typography>
                  <Typography>
                    By using Shahen's services, the customer acknowledges and agrees to all the
                    aforementioned terms and conditions and assumes full responsibility for paying
                    the fees according to Shahen's policy and complying with all stipulated terms
                    and conditions.
                  </Typography>
                  {/* <!--------------- Cancellation Fees Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Cancellation Fees:</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>TRAILA of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Before the carrier accepts the order, the customer can cancel without fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier accepts the order, the cancellation fee is 100 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier arrives at the loading site, the fee is 200 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After loading the goods or part of them, a fee of 450 SAR will be deducted
                      plus 100 SAR for each waiting hour or part thereof.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the order includes workers, 50 SAR will be deducted for each worker if
                      loading has not begun, and 100 SAR if the loading process has started, even if
                      not completed.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>SIX of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Before the carrier accepts the order, the customer can cancel without fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier accepts the order, the cancellation fee is 100 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier arrives at the loading site, the fee is 150 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After loading the goods or part of them, a fee of 400 SAR will be deducted
                      plus 100 SAR for each waiting hour or part thereof.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the order includes workers, 50 SAR will be deducted for each worker if
                      loading has not begun, and 100 SAR if the loading process has started, even if
                      not completed.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>LORRY of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Before the carrier accepts the order, the customer can cancel without fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier accepts the order, the cancellation fee is 75 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier arrives at the loading site, the fee is 125 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After loading the goods or part of them, a fee of 250 SAR will be deducted
                      plus 50 SAR for each waiting hour or part thereof.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the order includes workers, 50 SAR will be deducted for each worker if
                      loading has not begun, and 100 SAR if the loading process has started, even if
                      not completed.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>DIANA of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Before the carrier accepts the order, the customer can cancel without fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier accepts the order, the cancellation fee is 50 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier arrives at the loading site, the fee is 100 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After loading the goods or part of them, a fee of 150 SAR will be deducted
                      plus 50 SAR for each waiting hour or part thereof.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the order includes workers, 50 SAR will be deducted for each worker if
                      loading has not begun, and 100 SAR if the loading process has started, even if
                      not completed.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Pickup:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Before the carrier accepts the order, the customer can cancel without fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier accepts the order, the cancellation fee is 15 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After the carrier arrives at the loading site, the fee is 45 SAR.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      After loading the goods or part of them, a fee of 50 SAR will be deducted plus
                      10 SAR for each waiting hour or part thereof.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the order includes workers, 25 SAR will be deducted for each worker if
                      loading has not begun, and 50 SAR if the loading process has started, even if
                      not completed.
                    </ListItem>
                  </List>
                  {/* <!--------------- Delay Fees Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Delay Fees:</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>TRAILA of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is within the city and the delay exceeds two and a half
                      hours, a delay fee of 100 SAR is imposed, and an additional 50 SAR for each
                      extra hour, up to a maximum of the overnight fee.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is outside the city and the delay exceeds three hours, a
                      fee of 200 SAR is imposed, and an additional 50 SAR for each extra hour, up to
                      a maximum of the overnight fee.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>SIX of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is within the city and the delay exceeds two and a half
                      hours, a delay fee of 100 SAR is imposed, and an additional 40 SAR for each
                      extra hour, up to a maximum of the overnight fee.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is outside the city and the delay exceeds three hours, a
                      fee of 200 SAR is imposed, and an additional 50 SAR for each extra hour, up to
                      a maximum of the overnight fee.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>LORRY of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is within the city and the delay exceeds two and a half
                      hours, a delay fee of 75 SAR is imposed, and an additional 25 SAR for each
                      extra hour, up to a maximum of the overnight fee.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is outside the city and the delay exceeds three hours, a
                      fee of 150 SAR is imposed, and an additional 25 SAR for each extra hour, up to
                      a maximum of the overnight fee.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>DIANA of all types:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is within the city and the delay exceeds two hours, a delay
                      fee of 50 SAR is imposed, and an additional 20 SAR for each extra hour, up to
                      a maximum of the overnight fee.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the destination is outside the city and the delay exceeds three hours, a
                      fee of 75 SAR is imposed, and an additional 25 SAR for each extra hour, up to
                      a maximum of the overnight fee.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Pickup:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the delay exceeds one and a half hours, a delay fee of 25 SAR is imposed,
                      and an additional 25 SAR for each extra hour, up to a maximum of 125 SAR
                      excluding VAT.
                    </ListItem>
                  </List>
                  {/* <!--------------- Overnight Fees by Truck Type Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Overnight Fees by Truck Type:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    TRAILA of all types (except refrigerated):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      An overnight fee of 350 SAR is imposed for the first day and 1000 SAR for each
                      additional day, excluding VAT.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For all refrigerated TRAILA (refrigerated and frozen), an overnight fee of 450
                      SAR is imposed for the first day and 2000 SAR for each additional day,
                      excluding VAT.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    SIX of all types (except refrigerated):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      An overnight fee of 300 SAR is imposed for the first day and 900 SAR for each
                      additional day, excluding VAT.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For all refrigerated SIX (refrigerated and frozen), an overnight fee of 450
                      SAR is imposed for the first day and 1900 SAR for each additional day,
                      excluding VAT.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    LORRY of all types (except refrigerated):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      An overnight fee of 250 SAR is imposed for the first day and 750 SAR for each
                      additional day, excluding VAT.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For all refrigerated LORRY (refrigerated and frozen), an overnight fee of 350
                      SAR is imposed for the first day and 1500 SAR for each additional day,
                      excluding VAT.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    DIANA of all types (except refrigerated):
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      An overnight fee of 150 SAR is imposed for the first day and 650 SAR for each
                      additional day, excluding VAT.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For all refrigerated DIANA (refrigerated and frozen), an overnight fee of 250
                      SAR is imposed for the first day and 1000 SAR for each additional day,
                      excluding VAT.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Pickup:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      An overnight fee of 125 SAR is imposed for the first day and 250 SAR for each
                      additional day, excluding VAT.
                    </ListItem>
                  </List>
                  {/* <!--------------- Loading and Unloading Fees in Vital Areas Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Loading and Unloading Fees in Vital Areas:
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Definition of Vital Areas:
                    </Typography>{' '}
                    Vital areas include locations such as airports, city centers, ports, and streets
                    in the heart of major cities that may require special permits and cause
                    disruptions for the carrier and their truck. These locations are considered
                    sensitive due to the logistical challenges faced by drivers when arriving at or
                    departing from these areas.
                  </Typography>
                  {/* <!--------------- Loading and Unloading Fees in Vital Areas Related Terms --------------------------> */}
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Definition of Vital Areas:
                    </Typography>{' '}
                    Vital areas include locations such as:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      City Centers: Areas in the city center that are difficult to access or exit
                      due to traffic congestion or state regulations. This includes narrow streets,
                      vital and busy streets, and roads filled with retail and commercial shops.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Airports: Areas for loading or unloading goods within or around airports that
                      require special permits for entry and cause disruptions for the carrier and
                      their truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Ports: Areas for loading or unloading goods within or around ports that
                      require special permits for entry or exit and cause disruptions for the
                      carrier and their truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Government Establishments and Ministries: Areas for loading or unloading goods
                      within or around government establishments or ministries that require special
                      permits and cause disruptions for the carrier and their truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Dense Residential Areas: Areas in dense residential neighborhoods with
                      complete infrastructure and high traffic, making access or exit difficult.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Similar Examples of Vital Areas:
                    </Typography>
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Industrial Areas:
                      </Typography>{' '}
                      Specific industrial areas where traffic is heavy.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Universities and Major Hospitals:
                      </Typography>{' '}
                      Areas around universities or major hospitals that require special permits and
                      have heavy traffic.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Large Commercial Centers:
                      </Typography>{' '}
                      Areas around large commercial centers that are constantly congested.
                    </ListItem>
                  </List>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Possibility of Adding Other Areas:
                    </Typography>{' '}
                    Shahen reserves the right to add other areas to the list of vital areas at its
                    discretion and according to common practice in the Saudi market. The client is
                    obliged to pay the fees for loading or unloading in these areas according to
                    Shahen's vital areas policy and based on the truck's size and type. These fees
                    are added to the order invoice or issued as a separate external invoice
                    according to the situation and policy adopted by Shahen.
                  </Typography>
                  <Typography component="span" sx={{ fontWeight: 'bold' }}>
                    Shahen imposes additional fees for loading and unloading in vital areas due to
                    logistical difficulties and potential disruptions for drivers. These fees are as
                    follows:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        TRAILA of all types (except refrigerated):
                      </Typography>{' '}
                      Additional Fee: 500 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        TRAILA (refrigerated/frozen):
                      </Typography>{' '}
                      Additional Fee: 700 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        SIX of all types (except refrigerated):
                      </Typography>{' '}
                      Additional Fee: 450 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        SIX (refrigerated/frozen):
                      </Typography>{' '}
                      Additional Fee: 650 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        LORRY of all types (except refrigerated):
                      </Typography>{' '}
                      Additional Fee: 250 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        LORRY (refrigerated/frozen):
                      </Typography>{' '}
                      Additional Fee: 300 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        DIANA of all types (except refrigerated):
                      </Typography>{' '}
                      Additional Fee: 100 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        DIANA (refrigerated/frozen):
                      </Typography>{' '}
                      Additional Fee: 150 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Pickup:
                      </Typography>{' '}
                      Additional Fee: 50 SAR
                    </ListItem>
                  </List>
                  <Typography component="span" sx={{ fontWeight: 'bold' }}>
                    Terms and Conditions for Fees:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the loading site is vital and the unloading site is vital, the fees will be
                      charged twice; a fee for each site separately.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      These fees will be added to the order invoice or issued as a separate external
                      invoice according to the situation and the policy adopted by Shahen, and the
                      client is obliged to pay these fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The imposed fees include any additional fees that may result from delays or
                      overnight stays, and these fees can be combined in a single trip and on the
                      same order.
                    </ListItem>
                  </List>
                  {/* <!--------------- Unpaved Roads Fees and Policy Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Unpaved Roads Fees and Policy:
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Definition of Unpaved Roads:
                    </Typography>{' '}
                    Unpaved roads are those that are not paved or are rough or unsafe for the truck
                    and goods. These roads include any path lacking the basic infrastructure to
                    ensure the safety of the trucks and the goods transported on them.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Fees for Using Unpaved Roads:
                    </Typography>{' '}
                    Shahen imposes additional fees for using unpaved roads based on the distance
                    traveled per kilometer. These fees are as follows:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        TRAILA of all types:
                      </Typography>{' '}
                      Fee per kilometer: 35 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        SIX of all types:
                      </Typography>{' '}
                      Fee per kilometer: 35 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        LORRY:
                      </Typography>{' '}
                      Fee per kilometer: 25 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        DIANA:
                      </Typography>{' '}
                      Fee per kilometer: 20 SAR
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Pickup:
                      </Typography>{' '}
                      Fee per kilometer: 15 SAR
                    </ListItem>
                  </List>
                  <Typography component="span" sx={{ fontWeight: 'bold' }}>
                    Terms and Conditions for Fees:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The client bears any damage that may occur to the goods as a result of using
                      these roads.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The client is responsible for and covers the bills related to the truck
                      getting stuck or delayed on unpaved roads and any towing costs for the truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The client bears any damage that may occur to the carrier's trucks or property
                      and compensates for using unpaved roads.
                    </ListItem>
                  </List>
                  {/* <!--------------- Terms and Conditions of the Daily Truck Rental Service Related Terms ---------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Terms and Conditions of the Daily Truck Rental Service:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Daily Truck Rental Service Terms and Conditions
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Service Definition:
                    </Typography>{' '}
                    The daily rental service is provided by Shahen platform, offering customers a
                    truck with a driver for up to 8 hours a day. The customer can use the truck
                    during this time for loading and unloading at multiple points. The customer can
                    track the driver through the application.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Service Details and Additional Fees
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Additional fees apply if the customer exceeds the 8-hour limit, based on the
                      type and size of the truck, as follows: <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            TRAILA and SIX (excluding refrigerator):
                          </Typography>{' '}
                          119 SAR for each additional hour, with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            TRAILA and SIX (refrigerated/freezer):
                          </Typography>{' '}
                          169 SAR for each additional hour for refrigerated and 188 SAR for freezer,
                          with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            LORRY (excluding refrigerator):
                          </Typography>{' '}
                          88 SAR for each additional hour, with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            LORRY (refrigerated/freezer):
                          </Typography>{' '}
                          110 SAR for each additional hour for refrigerated and 125 SAR for freezer,
                          with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            DIANA (excluding refrigerator):
                          </Typography>{' '}
                          50 SAR for each additional hour, with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            DIANA (refrigerated/freezer):
                          </Typography>{' '}
                          94 SAR for each additional hour for refrigerated and 100 SAR for freezer,
                          with a maximum of a full-day rental fee.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            Pickup:
                          </Typography>{' '}
                          37 SAR for each additional hour, with a maximum of a full-day rental fee.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Full-Day Rental Fees: <br />
                      <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            TRAILA and SIX (excluding refrigerator):
                          </Typography>{' '}
                          1000 SAR
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            TRAILA and SIX (refrigerated/freezer):
                          </Typography>{' '}
                          1360 SAR for refrigerated and 1500 SAR for freezer.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            LORRY (excluding refrigerator):
                          </Typography>{' '}
                          600 SAR
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            LORRY (refrigerated/freezer):
                          </Typography>{' '}
                          875 SAR for refrigerated and 950 SAR for freezer.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            DIANA (excluding refrigerator):
                          </Typography>{' '}
                          500 SAR
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            DIANA (refrigerated/freezer):
                          </Typography>{' '}
                          750 SAR for refrigerated and 800 SAR for freezer.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          <Typography component="span" sx={{ fontWeight: 'bold' }}>
                            Pickup:
                          </Typography>{' '}
                          400 SAR
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Additional Terms and Conditions for Daily Rental
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The journey begins as soon as the driver arrives at the customer's location.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Delay fees are calculated up to the maximum daily rental fee, plus overnight
                      fees if the goods are stored in the driver's vehicle overnight.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The daily rental period is up to 16 hours or until midnight, whichever comes
                      first. If the customer exceeds this period, additional overnight fees are
                      applied in addition to the rental and delay fees.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Unused time cannot be carried over to another day.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the truck breaks down, Shahen is committed to providing a replacement
                      truck.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The driver is directed through direct communication with the driver provided
                      by Shahen. The customer can track the driver and know their location through
                      the app, but cannot send locations through the app. The customer can send
                      locations directly to the driver's number.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer is responsible for any fees or fines resulting from improper
                      loading or not following the regulations regarding the permitted weight for
                      loading according to traffic and government regulations.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer must provide Shahen with the journey information via email at
                      care@shahen-sa.com to inform the insurance company about the journey and cover
                      it.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      All other terms and conditions mentioned on the Shahen platform apply to the
                      daily rental service.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Client Responsibilities:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Adhering to the policies, terms, and conditions adopted by Shahen.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Correctly directing the driver and providing the necessary information to
                      ensure the truck reaches the specified points.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Paying all due fees on time according to Shahen's terms and conditions.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the client exceeds the specified hours for the truck, delay fees apply
                      according to the truck's type and size as mentioned in Shahen's terms and
                      conditions.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Not renting the truck to others without written consent from Shahen.
                    </ListItem>
                  </List>
                  {/* <!--------------- Obligations of the Parties Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Obligations of the Parties:
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Obligations of Shahen:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Provide trucks in good condition and insure the goods, except for those goods
                      excluded under the insurance and liability clauses.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Obligations of the Customer:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Adhere to the policies, terms, and conditions set by Shahen.
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Obligations of the Carrier:
                  </Typography>
                  {/* <!--------------- Cancellation and Modification Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Cancellation and Modification
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Orders cannot be modified or canceled after confirmation, except in
                      exceptional cases such as not using the credit at all, no canceled orders, or
                      no movement in the contract.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The package is valid for 30 days from the date of purchase.
                    </ListItem>
                  </List>
                  {/* <!--------------- Interaction with Drivers Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Interaction with Drivers
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Interaction with drivers outside the platform without written permission from
                      Shahen is prohibited.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Unauthorized interactions will result in contract cancellation and deduction
                      of the remaining contract value.
                    </ListItem>
                  </List>
                  {/* <!--------------- General Clauses Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>General Clauses</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      Shahen reserves the right to modify these terms and conditions.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the requested type of truck is not available, Shahen has the right to send
                      another truck of the same size or larger unless the transported product
                      requires a truck with specific features like refrigeration.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the loading site is not ready due to congestion or the goods are not ready,
                      Shahen has the right to withdraw the truck and send it to another order and
                      another customer, and send another truck instead. The lessor is not
                      responsible for any delays caused by the alternative truck's arrival.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer bears the cost of delays or overnight stays as specified in the
                      platform's terms of use and the estimated delay time for monthly packages.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The credit usage period is 30 days and cannot be carried over for any reason.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The same driver will carry out the customer's trips unless the number of trips
                      purchased by the customer in a month exceeds: <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>TRAILA: 24 trips</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>SIX: 24 trips</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>LORRY: 26 trips</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>DIANA: 52 trips</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Pickup: 60 trips</ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      If the customer needs to use a larger number of trips in one day, an
                      additional driver will be assigned according to the following schedule:
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          TRAILA: More than one trip
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>SIX: More than one trip</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          LORRY: More than two trips
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          DIANA: More than three trips
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Pickup: More than five trips
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  {/* <!--------------- Terms and Conditions for Shahen's Monthly Rental Service Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Terms and Conditions for Shahen's Monthly Rental Service
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Service Definition:
                    </Typography>{' '}
                    The monthly rental service from Shahen allows customers to rent trucks with a
                    driver for 26 days a month, with 8 working hours per day. The prices specified
                    in the application include insurance for the goods, provided their value and
                    type are disclosed during the contract. Shahen must be informed of the trips via
                    email at care@shahen-sa.com to notify the insurance company and cover the trip.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Terms and Conditions of Monthly Rental:
                  </Typography>
                  <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Rental Duration and Hours:
                      </Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The monthly rental period is 26 days a month, with 8 working hours per
                          day.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          If the customer exceeds the specified hours, delay fees apply according to
                          the truck's type and size as mentioned in Shahen's terms and conditions.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          If the trip duration exceeds 16 hours in one day or reaches 12:00
                          midnight, additional overnight fees will be imposed besides delay and
                          additional hour fees.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Trip Notification:
                      </Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer must provide Shahen with trip information via email at
                          care@shahen-sa.com before each trip to ensure insurance coverage.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Fees and Costs:
                      </Typography>
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          All other fees, such as delay and overnight fees, apply according to
                          Shahen's terms and conditions.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Storing goods in the trucks is not allowed, and the customer is
                          responsible for any damage to the goods.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Additional hour fees, excluding VAT, are as follows: <br />
                          <List sx={{ listStyleType: 'decimal', pl: 4 }}>
                            <ListItem sx={{ display: 'list-item' }}>
                              TRAILA and SIX (except refrigerated) - 119 SAR per additional hour, up
                              to a maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              TRAILA and SIX (refrigerated/frozen) - 169 SAR per additional hour, up
                              to a maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              LORRY (except refrigerated) - 88 SAR per additional hour, up to a
                              maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              LORRY (refrigerated/frozen) - 100 SAR per additional hour, up to a
                              maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              DIANA (except refrigerated) - 50 SAR per additional hour, up to a
                              maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              DIANA (refrigerated/frozen) - 94 SAR per additional hour, up to a
                              maximum of the full day's rental fee.
                            </ListItem>
                            <ListItem sx={{ display: 'list-item' }}>
                              Pickup - 37 SAR per additional hour, up to a maximum of the full day's
                              rental fee.
                            </ListItem>
                          </List>
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Rental and Reuse:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer is not allowed to rent the truck to others without written
                          consent from Shahen.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Unused periods cannot be carried over to the next month.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer cannot cancel the rental contract after assigning a driver to
                          the contract, even if the truck or contract is not used.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Truck Transfer and Direction:
                      </Typography>{' '}
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The truck cannot be transferred to work in another city not specified when
                          the request was made.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          The driver is directed through direct communication with the driver
                          provided by Shahen.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer can track the driver and know their location through the app
                          but cannot send locations through the app. Locations can be sent directly
                          to the driver's number.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Breakdown and Replacement:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          If the truck breaks down, Shahen is committed to providing a replacement
                          truck.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          Shahen can replace and change the driver during the contract period.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Logo Placement:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer can place their logos on the truck if the rental period
                          exceeds 6 months at their own expense.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          If the rental period is one year or more, the logo design and placement
                          are at Shahen's expense.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Trip Duration and Time Calculation:
                      </Typography>{' '}
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The trip duration starts upon the driver's arrival at the customer's
                          location, and traffic congestion and delays are calculated within the
                          truck's working hours.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer has the right to use the truck for loading and unloading at
                          multiple points.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          For trucks prohibited from moving within cities and in cases where it is
                          difficult to direct the truck after loading or unloading, working days are
                          calculated based on 26 days from the first day the contract starts. Any
                          additional day is calculated at the daily rental rate according to the
                          truck's type and size. "It is advised to review the daily rental rates
                          mentioned in Shahen's terms and conditions."
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Customer Responsibilities:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer bears any fees and fines resulting from improper loading or
                          non-compliance with the regulations regarding the permissible loading
                          weight according to traffic and governmental authorities and any costs
                          caused by the customer.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          The customer must read and understand all other applicable terms and
                          conditions mentioned on Shahen's platform.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        Pricing:
                      </Typography>
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          Prices are specified in the application according to Shahen's policy, and
                          Shahen reserves the right to modify prices at any time based on market
                          conditions and circumstances beyond Shahen's control, such as fuel price
                          increases or government decisions.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Important Notes:</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      All the terms and conditions mentioned above are binding once the customer
                      uses Shahen's services.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      The customer must adhere to all instructions and guidelines provided by Shahen
                      to ensure the process runs smoothly and efficiently.
                    </ListItem>
                  </List>
                  {/* <!--------------- Dispute Resolution Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Dispute Resolution</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Amicable Settlement:
                    </Typography>{' '}
                    In the event of any dispute or disagreement between the parties regarding the
                    execution or interpretation of this agreement, the parties shall make their best
                    efforts to amicably settle the dispute through direct negotiation. If no
                    amicable settlement is reached within fifteen (15) days from the commencement of
                    negotiations, the dispute shall be referred to arbitration under the terms
                    specified below.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Arbitration Resolution:
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Arbitration Agreement:
                    </Typography>{' '}
                    The parties agree that any dispute or disagreement arising from or related to
                    this agreement, including any matters relating to its interpretation or
                    execution, shall be finally resolved by arbitration in accordance with the rules
                    specified below.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Rules and Procedures:
                    </Typography>{' '}
                    Arbitration shall be conducted in accordance with the rules of the Saudi Center
                    for Commercial Arbitration.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Selection of Arbitrators:
                    </Typography>{' '}
                    Each party shall appoint one arbitrator, and the appointed arbitrators shall
                    appoint a third arbitrator to serve as the chairman of the arbitration panel. If
                    the arbitrators cannot agree on a third arbitrator within thirty (30) days, the
                    third arbitrator shall be appointed by the chosen arbitration center.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Venue of Arbitration:
                    </Typography>{' '}
                    Arbitration shall be conducted in Riyadh, Saudi Arabia.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Language of Arbitration:
                    </Typography>{' '}
                    The language of arbitration shall be Arabic unless otherwise agreed by the
                    parties.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Applicable Law:
                    </Typography>{' '}
                    This agreement and any disputes arising from it shall be governed by the laws
                    and regulations in force in Saudi Arabia.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Costs and Fees:
                    </Typography>{' '}
                    The losing party shall bear all arbitration costs, including arbitrators' fees,
                    administrative fees, and legal expenses. Shahen is entitled to demand the other
                    party to pay these costs upon the issuance of the arbitration award.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Confidentiality:
                    </Typography>{' '}
                    Arbitration proceedings and all related documents and information shall remain
                    confidential and shall not be disclosed to any third party without prior written
                    consent from all parties.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Binding Award:
                    </Typography>{' '}
                    The arbitration award shall be final and binding on both parties and may be
                    enforced in any court with competent jurisdiction.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Protection of Shahen's Rights:
                    </Typography>{' '}
                    Shahen reserves the right to take any necessary legal action to protect its
                    rights and interests, including halting the delivery of the shipment until due
                    fees are paid. The customer acknowledges their responsibility for any delay or
                    damage resulting from the delay in payment.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Acknowledgment and Cooperation:
                    </Typography>{' '}
                    The customer acknowledges their responsibility to fully cooperate with Shahen in
                    any legal or arbitration proceedings, including providing all necessary
                    documents and information to support and defend Shahen's claims. The customer
                    undertakes to indemnify Shahen and its employees and representatives and not to
                    sue them directly.
                  </Typography>
                  {/* <!--------------- Pricing Method Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Pricing Method</Typography>
                  <Typography>
                    The price of the transportation service on Shahen is determined by automatically
                    calculating the distance from the loading point to the final destination. For
                    some services such as monthly rental, trip packages, daily rental, and other
                    services, pricing is determined according to Shahen's policy. Shahen reserves
                    the right to adjust prices at any time based on market conditions and
                    circumstances beyond Shahen's control, including but not limited to fuel price
                    increases or government decisions. This price adjustment applies to all
                    contracts, including those concluded with customers.
                  </Typography>
                  {/* <!--------------- Invalidity of One or More Provisions Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Invalidity of One or More Provisions
                  </Typography>
                  <Typography>
                    The invalidity of any provision of these service provider terms does not affect
                    the validity of other provisions contained therein. If any provision in these
                    service provider terms is invalid or if a provision is unacceptable under
                    certain circumstances according to standards of reasonableness and fairness,
                    only to that extent, a provision that is acceptable and in line with the invalid
                    provision as much as possible shall be substituted, considering the content and
                    purpose of these service provider terms.
                  </Typography>
                  {/* <!--------------- Termination Clause Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>Termination Clause</Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Termination of the Agreement:
                    </Typography>{' '}
                    Shahen may terminate the agreement with any customer at any time and for any
                    reason, with prior notice to the customer. The customer may terminate the
                    agreement with Shahen by prior written notice, provided that they have fulfilled
                    all financial and non-financial obligations.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Contract Duration and Termination:
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      The contract between you and Shahen is indefinite. You have the right to
                      terminate the contract at any time by permanently deleting the app installed
                      on your smartphone, thereby disabling your use of the app and service. You can
                      also close your account at any time.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Shahen has the right to terminate the contract immediately at any time (by
                      disabling your use of the app and service) if you do any of the following:{' '}
                      <br />
                      <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                          Violate or breach any term of the service provider terms.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                          If Shahen considers that you are misusing the app or service.
                        </ListItem>
                      </List>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      Shahen is not obligated to send prior notice of contract termination.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For customers with contracts concluded with Shahen, they do not have the right
                      to terminate the contract and are obligated to comply with the contract terms
                      and penalties for termination and the specified notice period in that
                      contract. These terms apply to contracts entered into by direct agreement with
                      a specific company.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      For customers without previously concluded contracts who use Shahen's services
                      directly after registration, the terms and conditions are considered the
                      contract. These customers can terminate the engagement by deleting the app and
                      stopping use immediately unless there are specific terms or penalties in a
                      contract agreed upon previously.
                    </ListItem>
                  </List>
                  {/* <!--------------- Acknowledgment and Undertaking Related Terms --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    Acknowledgment and Undertaking
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Customer Acknowledgment:
                    </Typography>{' '}
                    I, the customer/authorized user of Shahen or any affiliated platform,
                    acknowledge that I have read and understood all the terms and conditions of
                    using the platform and agree to fully comply with them. I undertake to provide
                    accurate and correct information when using the platform and assume full
                    responsibility for any errors or negligence that may result from providing
                    incorrect or misleading information.
                    <br />
                    You acknowledge that you are solely responsible for the privacy of the services
                    and solely responsible for their use by any other person using your account
                    and/or username or password or other access credentials. You also agree to
                    notify Shahen if you become aware of any loss, theft, or unauthorized use of any
                    password, username, IP address, or other means of access to the services.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Undertaking to Pay Fees:
                    </Typography>{' '}
                    I undertake to pay all fees due and related to Shahen's services, including
                    cancellation fees, delay fees, overnight fees, unpaved road fees, and vital area
                    fees. I acknowledge that these fees may be added to the order invoice or issued
                    as a separate external invoice according to the platform's policy. I also
                    acknowledge that I cannot negotiate these fees or delay their payment and agree
                    that the platform has the right to take appropriate measures to ensure their
                    payment, including halting the delivery of the shipment.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Cooperation in Investigations and Claims:
                    </Typography>{' '}
                    I undertake to fully cooperate with Shahen in all investigations related to any
                    claim or dispute and provide all required documents and information to support
                    the investigation or claim. I undertake to indemnify Shahen and its employees
                    and representatives and not to sue them directly for any damage or loss that may
                    arise from using the platform's services.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Disclaimer:
                    </Typography>{' '}
                    I acknowledge that Shahen is not responsible for any direct, indirect,
                    consequential, special damages, or loss of profits that may arise from using the
                    platform's services. I agree that the platform's role is limited to directing
                    freight vehicles between me and the carrier. I acknowledge that I will not sue
                    Shahen, its employees, or its owners regarding any claim related to the services
                    provided.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Compliance with Laws and Regulations:
                    </Typography>{' '}
                    I undertake to comply with all applicable laws and regulations in Saudi Arabia
                    and assume full responsibility for any violations or breaches that may occur as
                    a result of using Shahen's services. I acknowledge that any dispute arising will
                    be resolved in accordance with Saudi laws and in the competent Saudi courts in
                    Riyadh.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Confidentiality of Information:
                    </Typography>{' '}
                    I acknowledge that I will maintain the confidentiality of all information
                    obtained through the use of the platform and undertake not to disclose any
                    confidential information to any third party without prior written consent from
                    Shahen.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Acceptance and Authorization:
                    </Typography>{' '}
                    I acknowledge that I am authorized to sign and commit on behalf of the company
                    or organization I represent and assume full responsibility for my obligations
                    and the obligations of the company or organization I represent under these terms
                    and conditions.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Updates and Amendments:
                    </Typography>{' '}
                    I undertake to review the terms and conditions periodically and agree that
                    Shahen reserves the right to amend these terms and conditions at any time, and
                    the amendments will be published on the platform's website. My continued use of
                    the services after the publication of the amendments constitutes my acceptance
                    of the amended terms.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      Acknowledgment of Indemnity:
                    </Typography>{' '}
                    I undertake to pay all indemnities related to any loss or damage arising from my
                    use of the platform and acknowledge that I will bear the costs and expenses
                    related to any lawsuit filed by third parties against Shahen due to any breach
                    on my part of any of the terms of use herein.
                  </Typography>
                  <br />
                  <Typography>
                    By this, I acknowledge and undertake full compliance with all the terms and
                    conditions for using Shahen, and I assume full responsibility for any violation
                    or breach of these terms.
                  </Typography>
                  <br />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
